import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavBar from '../Navbar/NavBar';

class Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            authProvider: null,
        }
    }
    logout = () => {
        this.props.logout();
    }
    render() {
        return (
            <div>
                <NavBar
                    href={this.props.href}
                    userToken={this.props.userToken}
                    logout={this.logout}
                    store={this.props.props.store}
                    pageTitle={this.props.pageTitle}
                    hubs={[]}
                />
                <main>{this.props.children}</main>

            </div>
        )
    }
}
const mapDispatchToProps = dispatch => ({
});
const mapStateToProps = state => ({
    userToken: {
        jwtAccessToken: state.aad.accessToken ? state.aad.accessToken.accessToken : '',
        idToken: state.aad.idToken ? state.aad.idToken.idToken.rawIdToken : '',
        userDetails: state.aad.account
    }
});
export default
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(Layout);